/*@flow*/
import type { Element } from 'react';
import React from 'react';
import humanize from 'underscore.string/humanize';
import { NonEmptyArray } from 'types/tcomb';

type ErrorT = { message: string, path?: string[] };

export default ({ errors }: { errors: ErrorT[] }): null | Element<'div'> => {
  if (!NonEmptyArray.is(errors)) return null;

  return (
    <div className="alert alert-warning" id="error-container">
      <h4>Errors</h4>
      <ul id="error-list">
        {errors.map(({ message, path }, i) => {
          const humanPath = path ? humanize(path.join(' ')) : '';
          return (
            <li key={i}>
              {humanPath}: {message}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
